<script setup lang="ts">
import { MyChipsProps } from "./MyChips.props"

const props = withDefaults(defineProps<MyChipsProps>(), {
  isWithIcon: false,
  canHide: true
})

const emit = defineEmits<{ (e: "onClose"): void }>()
const isHidden = ref(false)

;(function () {
  if (!props.canHide) return
  setTimeout(() => {
    isHidden.value = true
  }, 5000)
})()

const handleClose = () => {
  emit("onClose")
}
</script>

<template>
  <div v-if="!isHidden" class="chips-chips">
    <UtilsButton
      class="custom-btn-chips rounded-full bg-green-10 text-black-main md:flex"
      :class="[isWithIcon ? 'py-1 pl-3 pr-2' : 'px-4 py-2']"
      theme="ghost-black"
      :text="message"
      order="last"
    >
      <template v-if="isWithIcon" #icon>
        <UtilsIcon
          name="Close.svg"
          class="h-6 w-6 cursor-pointer"
          @click="handleClose"
        />
      </template>
    </UtilsButton>
  </div>
</template>
